import pinIcon from "@img/icon/pin.svg";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts/highmaps";
import React, { type FC, useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import type { PartnerOffice } from "../model/type";
import "highcharts/modules/tiledwebmap";

interface PartnerOfficeMapProps {
	className?: string;
	partnerOffices: PartnerOffice[];
}

export const PartnerOfficeMap: FC<PartnerOfficeMapProps> = ({ className, partnerOffices }) => {
	const isLoading = partnerOffices.length === 0;
	const [seriesData, setSeriesData] = useState<
		{
			name: string;
			lon: number;
			lat: number;
		}[]
	>([]);
	const [fitToGeometry, setFitToGeometry] = useState({
		type: "MultiPoint",
		coordinates: [[0, 0]],
	});

	useEffect(() => {
		if (partnerOffices.length > 0) {
			setSeriesData(
				partnerOffices.map((office) => ({
					name: office.name,
					lon: Number(office.longitude),
					lat: Number(office.latitude),
				})),
			);
			setFitToGeometry({
				type: "MultiPoint",
				coordinates: partnerOffices.map((office) => [Number(office.longitude), Number(office.latitude)]),
			});
		}
	}, [partnerOffices]);

	// NOTE: Because the Server-Side Rendering (SSR) of the map is not supported, we need to set the state to false after the component is mounted
	if (isLoading) {
		return <Skeleton height={400} width="100%" />;
	}

	return (
		<HighchartsReact
			containerProps={{ className }}
			highcharts={Highcharts}
			options={{
				credits: {
					enabled: false,
				},

				chart: {
					margin: 0,
				},

				title: {
					text: null,
				},

				subtitle: {
					text: null,
				},

				navigation: {
					buttonOptions: {
						align: "left",
						theme: {
							stroke: "#e6e6e6",
						},
					},
				},

				mapNavigation: {
					enabled: true,
					buttonOptions: {
						alignTo: "spacingBox",
					},
				},

				mapView: {
					fitToGeometry: fitToGeometry,
					padding: 64,
				},
				legend: false,

				tooltip: {
					pointFormat: "{point.name}",
				},

				plotOptions: {
					mappoint: {
						dataLabels: {
							enabled: false,
						},
					},
				},

				series: [
					{
						type: "tiledwebmap",
						name: "Basemap Tiles",
						provider: {
							type: "OpenStreetMap",
						},
						showInLegend: false,
					},
					{
						type: "mappoint",
						name: "Irodák",
						marker: {
							symbol: `url(${pinIcon})`,
							width: 32,
							height: 42,
						},
						data: seriesData,
					},
				],
			}}
			constructorType={"mapChart"}
		/>
	);
};
